import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ChatVerbali } from '../components/ChatVerbali';
import logoReconcilia from '../logo-reconcilia.png';
import {
  getProcedure, creaProc, modificaProc, eliminaProcedura, ripristinaProcedura, getCestino,
  creaVerbale, eliminaVerbale, ripristinaVerbale,
  uploadPdfVerbale, avviaGiroFirme,
  uploadPdfMediatore,
  inviaVerbaleFinale, saltaFirmatario,
  getRicevute, downloadAccettazione, downloadConsegna, archiviaInvioPec, controllRicevuteFirme,
  getPdfSteps, downloadPdfStep,
  getLogs,
  sospiendiSolleciti, riattivasollecitiSolleciti,
  modificaGiorniScadenza, modificaFirmatario, aggiungiFirmatarioVerbale,
  getArchivio, downloadArchivio, eliminaDaArchivio, aggiornaDatiArchivio,
  getMe, getMediatori, creaMediator, disabilitaUtente, resetPasswordUtente,
  getRubrica
} from '../services/api';

// --- Helper nomi file ---
function formatParti(parte: string): string {
  const items = parte.split(/[,;]/).map((s: string) => s.trim()).filter(Boolean);
  if (items.length === 0) return parte.replace(/\s+/g, '_').toLowerCase();
  const words = items[0].trim().split(/\s+/);
  const cognome = words[words.length - 1].toLowerCase();
  return items.length > 1 ? `${cognome}+${items.length - 1}` : cognome;
}
function formatProtocollo(proto: string): string {
  return proto.replace(/\//g, '_').replace(/\s+/g, '');
}
function nomeFilePdf(proto: string, p1: string, p2: string, data: string, descr: string): string {
  const pr = formatProtocollo(proto);
  const parti1 = formatParti(p1);
  const parti2 = formatParti(p2);
  let stato: string;
  if (descr === 'Verbale da firmare') stato = 'da firmare';
  else if (descr === 'PDF con firma del mediatore') stato = 'completo di firme';
  else stato = descr.toLowerCase().replace(/^pdf /, '').replace(/\s*\(firmatario\s*\d+\)/g, '').trim();
  return `${pr} ${parti1} vs ${parti2} verbale del ${data} ${stato}.pdf`.replace(/[<>:"/\\|?*]/g, '_');
}
function nomeFileRicevuta(proto: string, p1: string, p2: string, data: string, tipo: string, tipoRic: 'accettazione' | 'consegna', dest: string): string {
  const pr = formatProtocollo(proto);
  const parti1 = formatParti(p1);
  const parti2 = formatParti(p2);
  const statoInvio = tipo === 'link_firma' ? 'per firma' : 'completo di firme';
  const destPulito = dest.split('@')[0].replace(/[<>:"/\\|?*]/g, '_');
  const suffisso = tipoRic === 'accettazione' ? 'accettazione' : `consegna ${destPulito}`;
  return `${pr} ${parti1} vs ${parti2} trasmissione verbale del ${data} ${statoInvio} ${suffisso}.eml`.replace(/[<>:"/\\|?*]/g, '_');
}

interface FirmatarioForm {
  nome: string;
  email: string;
  ordine: number;
  tipo_notifica: string;
}

interface AdminProps {
  onLogout: () => void;
}

const TabSolleciti: React.FC<{ verbaleId: number }> = ({ verbaleId }) => {
  const [solleciti, setSolleciti] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('reconcilia_token');
    axios.get(`${process.env.REACT_APP_API_URL || 'https://firmereconcilia.it'}/api/verbali/${verbaleId}/solleciti`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => setSolleciti(res.data))
      .catch(e => console.error('Errore caricamento solleciti', e))
      .finally(() => setLoading(false));
  }, [verbaleId]);

  const scarica = async (sollecito_id: number, tipo: 'accettazione' | 'consegna') => {
    const token = localStorage.getItem('reconcilia_token');
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL || 'https://firmereconcilia.it'}/api/verbali/solleciti/${sollecito_id}/download-${tipo}`,
      { responseType: 'blob', headers: { Authorization: `Bearer ${token}` } }
    );
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `sollecito_${sollecito_id}_${tipo}.eml`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (loading) return <p style={{ color: '#999', marginTop: '0.5rem' }}>Caricamento...</p>;
  if (solleciti.length === 0) return (
    <p style={{ color: '#999', marginTop: '0.5rem' }}>Nessun sollecito con ricevuta disponibile. Le ricevute saranno visibili per i solleciti inviati da oggi in poi.</p>
  );

  return (
    <table style={{ width: '100%', marginTop: '0.5rem', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
      <thead>
        <tr style={{ background: '#dde', textAlign: 'left' }}>
          <th style={{ padding: '0.5rem', borderBottom: '1px solid #ccc' }}>Firmatario</th>
          <th style={{ padding: '0.5rem', borderBottom: '1px solid #ccc' }}>Data invio</th>
          <th style={{ padding: '0.5rem', borderBottom: '1px solid #ccc' }}>N° sollecito</th>
          <th style={{ padding: '0.5rem', borderBottom: '1px solid #ccc' }}>Ricevuta accettazione</th>
          <th style={{ padding: '0.5rem', borderBottom: '1px solid #ccc' }}>Ricevuta consegna</th>
        </tr>
      </thead>
      <tbody>
        {solleciti.map((s: any) => (
          <tr key={s.id} style={{ borderBottom: '1px solid #ddd' }}>
            <td style={{ padding: '0.5rem', verticalAlign: 'middle' }}>
              {s.firmatario_nome}<br />
              <span style={{ fontSize: '0.75rem', color: '#888' }}>{s.firmatario_email}</span>
            </td>
            <td style={{ padding: '0.5rem', verticalAlign: 'middle' }}>{s.data_invio ? new Date(s.data_invio).toLocaleString('it-IT') : '—'}</td>
            <td style={{ padding: '0.5rem', verticalAlign: 'middle' }}>{s.numero_sollecito}</td>
            <td style={{ padding: '0.5rem', verticalAlign: 'middle' }}>
              {s.ha_accettazione_eml
                ? <button onClick={() => scarica(s.id, 'accettazione')} style={{ padding: '0.2rem 0.5rem', background: '#27ae60', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.75rem' }}>⬇️ Scarica</button>
                : <span>—</span>}
            </td>
            <td style={{ padding: '0.5rem', verticalAlign: 'middle' }}>
              {s.ha_consegna_eml
                ? <button onClick={() => scarica(s.id, 'consegna')} style={{ padding: '0.2rem 0.5rem', background: '#27ae60', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.75rem' }}>⬇️ Scarica</button>
                : <span>—</span>}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const SuggerimentiRubrica: React.FC<{
  campo: 'nome' | 'email';
  value: string;
  onChange: (val: string) => void;
  onSelect: (voce: { nome: string | null; email: string }) => void;
  rubrica: { nome: string | null; email: string }[];
  placeholder?: string;
  wrapperStyle?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
}> = ({ campo, value, onChange, onSelect, rubrica, placeholder, wrapperStyle, inputStyle }) => {
  const [aperto, setAperto] = useState(false);
  const filtrati = value.length >= 2
    ? rubrica.filter(v => {
        const target = campo === 'nome' ? (v.nome || '') : v.email;
        return target.toLowerCase().includes(value.toLowerCase());
      })
    : [];
  return (
    <div style={{ position: 'relative', ...wrapperStyle }}>
      <input
        placeholder={placeholder}
        value={value}
        onChange={e => { onChange(e.target.value); setAperto(true); }}
        onFocus={() => setAperto(true)}
        onBlur={() => setTimeout(() => setAperto(false), 150)}
        style={{ width: '100%', boxSizing: 'border-box', ...inputStyle }}
      />
      {aperto && filtrati.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ccc', borderRadius: '4px', zIndex: 200, maxHeight: '180px', overflowY: 'auto', boxShadow: '0 4px 8px rgba(0,0,0,0.12)' }}>
          {filtrati.map((v, i) => (
            <div
              key={i}
              onMouseDown={() => { onSelect(v); setAperto(false); }}
              style={{ padding: '0.35rem 0.6rem', cursor: 'pointer', fontSize: '0.82rem', borderBottom: '1px solid #f0f0f0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
              onMouseEnter={e => (e.currentTarget.style.background = '#eef4ff')}
              onMouseLeave={e => (e.currentTarget.style.background = 'white')}
            >
              {v.nome || '—'} — {v.email}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default function Admin({ onLogout }: AdminProps) {
  const [procedure, setProcedure] = useState<any[]>([]);
  const [vista, setVista] = useState<'lista' | 'nuova-procedura' | 'nuovo-verbale' | 'logs' | 'cestino' | 'archivio' | 'mediatori'>('lista');
  const [cestino, setCestino] = useState<{procedure: any[], verbali: any[]}>({procedure: [], verbali: []});
  const [archivio, setArchivio] = useState<any[]>([]);
  const [proceduraSelezionata, setProceduraSelezionata] = useState<any>(null);
  const [messaggiVerbale, setMessaggiVerbale] = useState<{[key: number]: string}>({});
  const [ricevutePerVerbale, setRicevutePerVerbale] = useState<{[key: number]: any[]}>({});
  const [cooldownVerbali, setCooldownVerbali] = useState<{[key: number]: number}>({});
  const [verbaliAperti, setVerbaliAperti] = useState<{[key: number]: boolean}>({});
  const [pdfStepsPerVerbale, setPdfStepsPerVerbale] = useState<{[key: number]: any[]}>({});
  const [pdfStepsAperti, setPdfStepsAperti] = useState<{[key: number]: boolean}>({});
  const [sollecitiRicevuteAperti, setSollecitiRicevuteAperti] = useState<{[key: number]: boolean}>({});
  const [procedureAperte, setProcedureAperte] = useState<{[key: number]: boolean}>({});
  const [logs, setLogs] = useState<any[]>([]);
  const [ricerca, setRicerca] = useState('');
  const [ordinamento, setOrdinamento] = useState<'asc' | 'desc'>('asc');
  const [tipoOrdinamento, setTipoOrdinamento] = useState<'protocollo' | 'verbale'>('protocollo');
  const [filtroStato, setFiltroStato] = useState<string>('tutte');
  const [filtroCreatore, setFiltroCreatore] = useState<string>('tutte');
  const [modificaProcId, setModificaProcId] = useState<number | null>(null);
  const [formModificaProc, setFormModificaProc] = useState<{numero: string, anno: string, parte1: string, parte2: string}>({ numero: '', anno: String(new Date().getFullYear()), parte1: '', parte2: '' });
  const [editOrphanId, setEditOrphanId] = useState<number | null>(null);
  const [editOrphanForm, setEditOrphanForm] = useState<{protocollo: string, parte1: string, parte2: string}>({ protocollo: '', parte1: '', parte2: '' });
  const [anniArchivioAperti, setAnniArchivioAperti] = useState<{[anno: number]: boolean}>({});
  const [ricercaArchivio, setRicercaArchivio] = useState('');
  const [menuAperto, setMenuAperto] = useState(false);
  const [pdfPreview, setPdfPreview] = useState<{open: boolean, url: string, filename: string, loading: boolean}>({ open: false, url: '', filename: '', loading: false });
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [rubrica, setRubrica] = useState<{ nome: string | null; email: string }[]>([]);

  // Stato utente corrente e mediatori
  const [currentUser, setCurrentUser] = useState<{id: number, email: string, nome: string | null, role: string} | null>(null);
  const [mediatori, setMediatori] = useState<any[]>([]);
  const [modalCreaMediatore, setModalCreaMediatore] = useState<{open: boolean, email: string, nome: string}>({ open: false, email: '', nome: '' });
  const [passwordTemporanea, setPasswordTemporanea] = useState<{open: boolean, email: string, password: string} | null>(null);

  // Stato per modifica firmatari
  const [firmatarioInModifica, setFirmatarioInModifica] = useState<{[key: number]: {nome: string, email: string}}>({});
  const [firmatariModificaAperti, setFirmatariModificaAperti] = useState<{[key: number]: boolean}>({});

  // Stato per aggiunta firmatario
  const [aggiungiAperti, setAggiungiAperti] = useState<{[key: number]: boolean}>({});
  const [nuoviFirmatari, setNuoviFirmatari] = useState<{[key: number]: {nome: string, email: string, ordine: number, tipo_notifica: string}}>({});

  // Stato per modifica giorni scadenza
  const [giorniModificaAperti, setGiorniModificaAperti] = useState<{[key: number]: boolean}>({});
  const [nuoviGiorni, setNuoviGiorni] = useState<{[key: number]: number}>({});
  const [caricandoMediatore, setCaricandoMediatore] = useState<{[key: number]: boolean}>({});

  const [formProcedura, setFormProcedura] = useState({ numero: '', anno: String(new Date().getFullYear()), parte1: '', parte2: '' });
  const [formVerbale, setFormVerbale] = useState({ numero: 1, data_verbale: '', modalita_firma: 'parallela', giorni_scadenza: 2 });
  const [firmatari, setFirmatari] = useState<FirmatarioForm[]>([{ nome: '', email: '', ordine: 1, tipo_notifica: 'pec' }]);

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { caricaMe(); caricaProcedure(); caricaRubrica(); }, []);
  useEffect(() => {
    const intervallo = setInterval(() => { caricaProcedure(); }, 30000);
    return () => clearInterval(intervallo);
  }, []);

  const caricaMe = async () => {
    try {
      const res = await getMe();
      setCurrentUser(res.data);
    } catch (e) {}
  };

  const caricaRubrica = async () => {
    try {
      const res = await getRubrica();
      setRubrica(res.data);
    } catch (e) {}
  };

  const caricaMediatori = async () => {
    try {
      const res = await getMediatori();
      setMediatori(res.data);
    } catch (e) {}
  };

  const handleCreaMediator = async () => {
    if (!modalCreaMediatore.email) return;
    try {
      const res = await creaMediator({ email: modalCreaMediatore.email, nome: modalCreaMediatore.nome || undefined });
      setModalCreaMediatore({ open: false, email: '', nome: '' });
      setPasswordTemporanea({ open: true, email: res.data.email, password: res.data.password });
      caricaMediatori();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Errore nella creazione');
    }
  };

  const handleResetPassword = async (id: number, email: string) => {
    if (!window.confirm(`Reset password per ${email}?`)) return;
    try {
      const res = await resetPasswordUtente(id);
      setPasswordTemporanea({ open: true, email, password: res.data.password });
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Errore nel reset');
    }
  };

  const handleDisabilitaUtente = async (id: number, email: string) => {
    if (!window.confirm(`Disabilitare ${email}?`)) return;
    try {
      await disabilitaUtente(id);
      caricaMediatori();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Errore');
    }
  };

  const caricaProcedure = async () => {
    try {
      const res = await getProcedure();
      setProcedure(res.data);
    } catch (e) { console.error('Errore caricamento procedure'); }
  };

  const caricaProcedureEApri = async (id: number) => {
    try {
      const res = await getProcedure();
      setProcedure(res.data);
      setProcedureAperte(prev => ({ ...prev, [id]: true }));
      setVista('lista');
      setTimeout(() => {
        const el = document.getElementById(`procedura-${id}`);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    } catch (e) { console.error('Errore caricamento procedure'); }
  };

  const caricaLogs = async () => {
    try {
      const res = await getLogs();
      setLogs(res.data);
    } catch (e) { console.error('Errore caricamento log'); }
  };

  const caricaCestino = async () => {
    try {
      const res = await getCestino();
      setCestino(res.data);
    } catch (e) { console.error('Errore caricamento cestino'); }
  };

  const caricaArchivio = async () => {
    try {
      const res = await getArchivio();
      setArchivio(res.data);
    } catch (e) { console.error('Errore caricamento archivio'); }
  };

  const scaricaArchivio = (v: any) => {
    apriPreviewPdf(
      () => downloadArchivio(v.id),
      nomeFilePdf(v.procedura_protocollo, v.procedura_parte1, v.procedura_parte2, v.data_verbale, 'PDF con firma del mediatore')
    );
  };

  const eliminaArchivio = async (verbale_id: number) => {
    if (!window.confirm('Eliminare definitivamente questo verbale dall\'archivio? L\'operazione è irreversibile.')) return;
    try {
      await eliminaDaArchivio(verbale_id);
      await caricaArchivio();
    } catch (e) { alert('Errore eliminazione'); }
  };

  const ripristinaProceduraClick = async (id: number) => {
    try {
      await ripristinaProcedura(id);
      await caricaCestino();
      await caricaProcedure();
    } catch (e) { alert('Errore ripristino procedura'); }
  };

  const ripristinaVerbaleClick = async (id: number) => {
    try {
      await ripristinaVerbale(id);
      await caricaCestino();
      await caricaProcedure();
    } catch (e) { alert('Errore ripristino verbale'); }
  };

  const mostraMessaggioVerbale = (verbale_id: number, msg: string) => {
    setMessaggiVerbale(prev => ({ ...prev, [verbale_id]: msg }));
    setTimeout(() => setMessaggiVerbale(prev => ({ ...prev, [verbale_id]: '' })), 5000);
  };

  const caricaRicevute = async (verbale_id: number) => {
    try {
      const res = await getRicevute(verbale_id);
      setRicevutePerVerbale(prev => ({ ...prev, [verbale_id]: res.data }));
    } catch (e) { console.error('Errore caricamento ricevute'); }
  };

  const avviaControlloRicevute = async (verbaleId: number) => {
    try {
      await controllRicevuteFirme(verbaleId);
      await caricaRicevute(verbaleId);
    } catch (e) {}

    let secondi = 60;
    setCooldownVerbali(prev => ({ ...prev, [verbaleId]: secondi }));
    const interval = setInterval(() => {
      secondi -= 1;
      setCooldownVerbali(prev => ({ ...prev, [verbaleId]: secondi }));
      if (secondi <= 0) {
        clearInterval(interval);
        setCooldownVerbali(prev => {
          const next = { ...prev };
          delete next[verbaleId];
          return next;
        });
      }
    }, 1000);
  };

  const toggleRicevute = async (verbale_id: number) => {
    const aperto = verbaliAperti[verbale_id];
    setVerbaliAperti(prev => ({ ...prev, [verbale_id]: !aperto }));
    if (!aperto) await caricaRicevute(verbale_id);
  };

  // Auto-aggiorna le ricevute ogni 30s per i pannelli aperti
  useEffect(() => {
    const intervallo = setInterval(() => {
      Object.entries(verbaliAperti).forEach(([id, aperto]) => {
        if (aperto) caricaRicevute(Number(id));
      });
    }, 30000);
    return () => clearInterval(intervallo);
  }, [verbaliAperti]);

  const caricaPdfSteps = async (verbale_id: number) => {
    try {
      const res = await getPdfSteps(verbale_id);
      setPdfStepsPerVerbale(prev => ({ ...prev, [verbale_id]: res.data }));
    } catch (e) { console.error('Errore caricamento PDF steps'); }
  };

  const togglePdfSteps = async (verbale_id: number) => {
    const aperto = pdfStepsAperti[verbale_id];
    setPdfStepsAperti(prev => ({ ...prev, [verbale_id]: !aperto }));
    if (!aperto) await caricaPdfSteps(verbale_id);
  };

  const toggleProcedura = (id: number) => {
    setProcedureAperte(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const apriPreviewPdf = async (fetchFn: () => Promise<any>, filename: string) => {
    setPdfPreview({ open: true, url: '', filename, loading: true });
    try {
      const res = await fetchFn();
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      setPdfPreview({ open: true, url, filename, loading: false });
    } catch (e) {
      setPdfPreview({ open: false, url: '', filename: '', loading: false });
      alert('Errore apertura PDF');
    }
  };

  const chiudiPreview = () => {
    if (pdfPreview.url) window.URL.revokeObjectURL(pdfPreview.url);
    setPdfPreview({ open: false, url: '', filename: '', loading: false });
  };

  const scaricaFile = async (fetchFn: () => Promise<any>, filename: string) => {
    try {
      const res = await fetchFn();
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url; a.download = filename; a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) { console.error('Errore download file'); }
  };

  const scaricaPdfStep = (step_id: number, protocollo: string, parte1: string, parte2: string, dataVerbale: string, descrizione: string) => {
    apriPreviewPdf(() => downloadPdfStep(step_id), nomeFilePdf(protocollo, parte1, parte2, dataVerbale, descrizione));
  };

  const creaNuovaProcedura = async () => {
    if (!formProcedura.numero || !formProcedura.parte1 || !formProcedura.parte2) { alert('Compila tutti i campi'); return; }
    const protocollo = `${formProcedura.numero}_${formProcedura.anno}`;
    try {
      const res = await creaProc({ protocollo, anno_protocollo: parseInt(formProcedura.anno), parte1: formProcedura.parte1, parte2: formProcedura.parte2 });
      const nuovoId = res.data.id;
      setFormProcedura({ numero: '', anno: String(new Date().getFullYear()), parte1: '', parte2: '' });
      await caricaProcedureEApri(nuovoId);
    } catch (e: any) { alert(e.response?.data?.detail || 'Errore nella creazione'); }
  };

  const elimina = async (id: number) => {
    if (!window.confirm('Eliminare definitivamente questa procedura e tutti i suoi verbali?')) return;
    try { await eliminaProcedura(id); caricaProcedure(); }
    catch (e) { alert('Errore eliminazione procedura'); }
  };

  const apriNuovoVerbale = (procedura: any) => {
    setProceduraSelezionata(procedura);
    setFormVerbale({ numero: 1, data_verbale: '', modalita_firma: 'parallela', giorni_scadenza: 2 });
    setFirmatari([{ nome: '', email: '', ordine: 1, tipo_notifica: 'pec' }]);
    setVista('nuovo-verbale');
  };

  const aggiungiFirmatario = () => {
    setFirmatari([...firmatari, { nome: '', email: '', ordine: firmatari.length + 1, tipo_notifica: 'pec' }]);
  };

  const aggiorniFirmatario = (index: number, campo: string, valore: string) => {
    const nuovi = [...firmatari];
    nuovi[index] = { ...nuovi[index], [campo]: valore };
    setFirmatari(nuovi);
  };

  const rimuoviFirmatario = (index: number) => {
    const nuovi = firmatari.filter((_, i) => i !== index).map((f, i) => ({ ...f, ordine: i + 1 }));
    setFirmatari(nuovi);
  };

  const creaNuovoVerbale = async () => {
    if (!formVerbale.data_verbale) { alert('Inserisci la data del verbale'); return; }
    if (firmatari.some(f => !f.nome || !f.email)) { alert('Compila nome e email di tutti i firmatari'); return; }
    try {
      const idProcedura = proceduraSelezionata.id;
      await creaVerbale({ procedura_id: idProcedura, ...formVerbale, firmatari });
      await caricaProcedureEApri(idProcedura);
    } catch (e: any) { alert(e.response?.data?.detail || 'Errore nella creazione del verbale'); }
  };

  const eliminaVerbaleClick = async (verbale_id: number) => {
    if (!window.confirm('Eliminare definitivamente questo verbale e tutti i suoi file?')) return;
    try { await eliminaVerbale(verbale_id); caricaProcedure(); }
    catch (e) { alert('Errore eliminazione verbale'); }
  };

  const caricaPdf = async (verbale_id: number, file: File) => {
    try {
      await uploadPdfVerbale(verbale_id, file);
      mostraMessaggioVerbale(verbale_id, '✅ PDF verbale caricato!'); caricaProcedure();
    } catch (e) { mostraMessaggioVerbale(verbale_id, '❌ Errore caricamento PDF'); }
  };

  const avviaFirme = async (verbale_id: number) => {
    try {
      const res = await avviaGiroFirme(verbale_id);
      mostraMessaggioVerbale(verbale_id, `✅ PEC inviate a: ${res.data.inviati.join(', ')}`); caricaProcedure();
    } catch (e: any) { mostraMessaggioVerbale(verbale_id, `❌ ${e.response?.data?.detail || 'Errore'}`); }
  };



  const caricaMediatore = async (verbale_id: number, file: File, procedura_id: number) => {
    setCaricandoMediatore(prev => ({ ...prev, [verbale_id]: true }));
    mostraMessaggioVerbale(verbale_id, '⏳ Caricamento PDF mediatore in corso...');
    try {
      await uploadPdfMediatore(verbale_id, file);
      mostraMessaggioVerbale(verbale_id, '✅ PDF mediatore caricato con successo!');
      setFiltroStato('tutte');
      await caricaProcedureEApri(procedura_id);
    } catch (e) {
      mostraMessaggioVerbale(verbale_id, '❌ Errore durante il caricamento del PDF mediatore');
    } finally {
      setCaricandoMediatore(prev => ({ ...prev, [verbale_id]: false }));
    }
  };

  const inviaFinale = async (verbale_id: number, procedura_id: number) => {
    try {
      const res = await inviaVerbaleFinale(verbale_id);
      mostraMessaggioVerbale(verbale_id, `✅ Verbale finale inviato a: ${res.data.inviati.join(', ')}`);
      setFiltroStato('tutte');
      await caricaProcedureEApri(procedura_id);
    } catch (e: any) { mostraMessaggioVerbale(verbale_id, `❌ ${e.response?.data?.detail || 'Errore'}`); }
  };

  const salta = async (firmatario_id: number, verbale_id: number) => {
    try {
      const res = await saltaFirmatario(firmatario_id);
      mostraMessaggioVerbale(verbale_id, `✅ ${res.data.messaggio}`); caricaProcedure();
    } catch (e) { mostraMessaggioVerbale(verbale_id, '❌ Errore nel saltare il firmatario'); }
  };

  const toggleSolleciti = async (verbale: any) => {
    try {
      if (verbale.solleciti_sospesi) {
        await riattivasollecitiSolleciti(verbale.id);
        mostraMessaggioVerbale(verbale.id, '✅ Solleciti riattivati');
      } else {
        await sospiendiSolleciti(verbale.id);
        mostraMessaggioVerbale(verbale.id, '✅ Solleciti sospesi');
      }
      caricaProcedure();
    } catch (e) { mostraMessaggioVerbale(verbale.id, '❌ Errore'); }
  };

  const salvaModificaFirmatario = async (firmatario_id: number, verbale_id: number) => {
    const dati = firmatarioInModifica[firmatario_id];
    if (!dati?.nome || !dati?.email) { alert('Compila nome e email'); return; }
    try {
      const res = await modificaFirmatario(firmatario_id, dati);
      mostraMessaggioVerbale(verbale_id, `✅ ${res.data.messaggio}`);
      setFirmatariModificaAperti(prev => ({ ...prev, [firmatario_id]: false }));
      caricaProcedure();
    } catch (e: any) { mostraMessaggioVerbale(verbale_id, `❌ ${e.response?.data?.detail || 'Errore'}`); }
  };

  const salvaAggiuntaFirmatario = async (verbale_id: number) => {
    const dati = nuoviFirmatari[verbale_id];
    if (!dati?.nome || !dati?.email || !dati?.ordine) { alert('Compila tutti i campi'); return; }
    try {
      await aggiungiFirmatarioVerbale(verbale_id, dati);
      mostraMessaggioVerbale(verbale_id, '✅ Firmatario aggiunto');
      setAggiungiAperti(prev => ({ ...prev, [verbale_id]: false }));
      setNuoviFirmatari(prev => ({ ...prev, [verbale_id]: { nome: '', email: '', ordine: 1, tipo_notifica: 'pec' } }));
      caricaProcedure();
    } catch (e: any) { mostraMessaggioVerbale(verbale_id, `❌ ${e.response?.data?.detail || 'Errore'}`); }
  };

  const salvaGiorniScadenza = async (verbale_id: number) => {
    const giorni = nuoviGiorni[verbale_id];
    if (!giorni || giorni < 1) { alert('Inserisci un numero valido'); return; }
    try {
      await modificaGiorniScadenza(verbale_id, giorni);
      mostraMessaggioVerbale(verbale_id, '✅ Giorni scadenza aggiornati');
      setGiorniModificaAperti(prev => ({ ...prev, [verbale_id]: false }));
      caricaProcedure();
    } catch (e: any) { mostraMessaggioVerbale(verbale_id, `❌ ${e.response?.data?.detail || 'Errore'}`); }
  };

  const salvaModificaProc = async (id: number) => {
    if (!formModificaProc.numero || !formModificaProc.parte1 || !formModificaProc.parte2) { alert('Compila tutti i campi'); return; }
    const protocollo = `${formModificaProc.numero}_${formModificaProc.anno}`;
    try {
      await modificaProc(id, { protocollo, anno_protocollo: parseInt(formModificaProc.anno), parte1: formModificaProc.parte1, parte2: formModificaProc.parte2 });
      setModificaProcId(null);
      await caricaProcedure();
    } catch (e: any) { alert(e.response?.data?.detail || 'Errore nel salvataggio'); }
  };

  const salvaOrfano = async (verbale_id: number) => {
    if (!editOrphanForm.protocollo || !editOrphanForm.parte1 || !editOrphanForm.parte2) { alert('Compila tutti i campi'); return; }
    try {
      await aggiornaDatiArchivio(verbale_id, { protocollo_archiviato: editOrphanForm.protocollo, parte1_archiviato: editOrphanForm.parte1, parte2_archiviato: editOrphanForm.parte2 });
      setEditOrphanId(null);
      await caricaArchivio();
    } catch (e: any) { alert(e.response?.data?.detail || 'Errore nel salvataggio'); }
  };

  const ANNI_DROPDOWN = Array.from({ length: 26 }, (_, i) => 2010 + i); // 2010–2035

  const parseProtocolloForm = (protocollo: string) => {
    const parti = protocollo.split(/[_/]/);
    if (parti.length >= 2) {
      const last = parti[parti.length - 1];
      const first = parti.slice(0, parti.length - 1).join('_');
      const annoNum = parseInt(last);
      const anno = annoNum < 100 ? String(2000 + annoNum) : String(annoNum);
      return { numero: first, anno };
    }
    return { numero: protocollo, anno: String(new Date().getFullYear()) };
  };

  const ordinaProtocollo = (a: any, b: any) => {
    if (tipoOrdinamento === 'verbale') {
      const ultimoA = a.verbali?.reduce((max: number, v: any) => Math.max(max, v.id ?? 0), 0) ?? 0;
      const ultimoB = b.verbali?.reduce((max: number, v: any) => Math.max(max, v.id ?? 0), 0) ?? 0;
      return ordinamento === 'asc' ? ultimoA - ultimoB : ultimoB - ultimoA;
    }
    const parseProtocollo = (p: string) => {
      const match = p.match(/(\d+)[_\/\-](\d+)/);
      if (!match) return { num: 0, anno: 0 };
      const num = parseInt(match[1]);
      const anno = parseInt(match[2]);
      return { num, anno: anno < 100 ? anno + 2000 : anno };
    };
    const pa = parseProtocollo(a.protocollo);
    const pb = parseProtocollo(b.protocollo);
    if (pa.anno !== pb.anno) return ordinamento === 'asc' ? pa.anno - pb.anno : pb.anno - pa.anno;
    return ordinamento === 'asc' ? pa.num - pb.num : pb.num - pa.num;
  };

  const firmatariInScadenza = (v: any): any[] => {
    if (!v.firmatari) return [];
    const ora = Date.now();
    const ORE_48 = 48 * 60 * 60 * 1000;
    return v.firmatari.filter((f: any) => {
      if (f.stato !== 'in_attesa' || !f.data_invio_link || !f.giorni_limite) return false;
      const scadenza = new Date(f.data_invio_link).getTime() + f.giorni_limite * 24 * 60 * 60 * 1000;
      return scadenza - ora <= ORE_48 && scadenza - ora > 0;
    });
  };

  const proceduraHaScadenze = (p: any): boolean =>
    p.verbali?.some((v: any) => firmatariInScadenza(v).length > 0) || false;

  const statoProcedura = (p: any) => {
    const stati = p.verbali?.map((v: any) => v.stato) || [];
    if (stati.includes('firme_completate')) return { label: '🔴 Manca firma mediatore', colore: '#c0392b', key: 'firme_completate' };
    if (stati.includes('in_corso')) return { label: '🟠 In corso di firma', colore: '#e67e22', key: 'in_corso' };
    if (stati.includes('pronta_per_l_invio')) return { label: '🟣 Pronta per l\'invio', colore: '#8e44ad', key: 'pronta_per_l_invio' };
    if (stati.includes('completata')) return { label: '🟢 Completata', colore: '#27ae60', key: 'completata' };
    return { label: '⚪ Nessun verbale', colore: '#95a5a6', key: '' };
  };

  const procedureFiltrate = procedure
    .filter(p => {
      const q = ricerca.toLowerCase();
      const matchRicerca = !q || p.protocollo.toLowerCase().includes(q) ||
        p.parte1.toLowerCase().includes(q) || p.parte2.toLowerCase().includes(q);
      const matchFiltro = filtroStato === 'tutte' || statoProcedura(p).key === filtroStato ||
        (filtroStato === 'in_scadenza' && proceduraHaScadenze(p));
      const matchCreatore = filtroCreatore === 'tutte' ||
        (filtroCreatore === 'mediatore' && p.creato_da?.role === 'mediatore') ||
        (filtroCreatore === 'segreteria' && p.creato_da?.role !== 'mediatore');
      return matchRicerca && matchFiltro && matchCreatore;
    })
    .sort((a, b) => {
      if (filtroCreatore === 'mediatore') {
        const nA = (a.creato_da?.nome || a.creato_da?.email || '').toLowerCase();
        const nB = (b.creato_da?.nome || b.creato_da?.email || '').toLowerCase();
        if (nA !== nB) return nA.localeCompare(nB, 'it');
      }
      return ordinaProtocollo(a, b);
    });

  const statoColore = (stato: string) => ({
    in_corso: '#e67e22', firme_completate: '#2980b9',
    pronta_per_l_invio: '#8e44ad', completata: '#27ae60'
  }[stato] || '#7f8c8d');

  const statoFirmatarioColore = (stato: string) => ({
    in_attesa: '#e67e22', firmato: '#27ae60',
    saltato: '#7f8c8d', scaduto: '#c0392b'
  }[stato] || '#7f8c8d');

  const giroFirmeAvviato = (v: any) => v.firmatari?.some((f: any) => f.data_invio_link);

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif', maxWidth: '960px', margin: '0 auto' }}>

      {/* MODALE ANTEPRIMA PDF */}
      {pdfPreview.open && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', borderRadius: '8px', width: '92vw', height: '92vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.4)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.8rem 1rem', borderBottom: '1px solid #ddd', background: '#f5f5f5', flexShrink: 0 }}>
              <span style={{ fontWeight: 'bold', fontSize: '0.85rem', color: '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '70%' }}>{pdfPreview.filename}</span>
              <div style={{ display: 'flex', gap: '0.5rem', flexShrink: 0 }}>
                {pdfPreview.url && (
                  <a href={pdfPreview.url} download={pdfPreview.filename} style={{ padding: '0.4rem 0.9rem', background: '#2980b9', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.85rem', textDecoration: 'none', display: 'inline-block' }}>⬇️ Scarica</a>
                )}
                <button onClick={chiudiPreview} style={{ padding: '0.4rem 0.9rem', background: '#c0392b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.85rem' }}>✕ Chiudi</button>
              </div>
            </div>
            {pdfPreview.loading ? (
              <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem', color: '#666' }}>⏳ Caricamento PDF...</div>
            ) : (
              <iframe src={pdfPreview.url} style={{ flex: 1, border: 'none', width: '100%' }} title="Anteprima PDF" />
            )}
          </div>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '3px solid #9f0408' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <img src={logoReconcilia} alt="Reconcilia ADR" style={{ height: '60px', width: 'auto' }} />
          <div>
            <h1 style={{ color: '#9f0408', margin: 0, fontSize: '1.4rem', fontWeight: 'bold' }}>Reconcilia ADR</h1>
            <span style={{ color: '#666', fontSize: '0.85rem' }}>
              {currentUser ? `${currentUser.nome || currentUser.email} (${currentUser.role})` : 'Pannello Amministratore'}
            </span>
          </div>
        </div>
        <button onClick={onLogout} style={{ padding: '0.5rem 1rem', background: '#9f0408', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem' }}>
          Logout
        </button>
      </div>

      <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          <button onClick={() => setVista('lista')} style={btnStyle(vista === 'lista')}>📋 Lista Procedure</button>
          <button onClick={() => setVista('nuova-procedura')} style={btnStyle(vista === 'nuova-procedura')}>➕ Nuova Procedura</button>
          {currentUser?.role === 'superadmin' && (
            <button onClick={() => { setVista('mediatori'); caricaMediatori(); }} style={btnStyle(vista === 'mediatori')}>👥 Mediatori</button>
          )}
        </div>
        <div style={{ position: 'relative' }}>
          <button
            onClick={() => setMenuAperto(p => !p)}
            style={{ padding: '0.4rem 0.8rem', background: ['archivio','cestino','logs'].includes(vista) ? '#555' : 'transparent', color: ['archivio','cestino','logs'].includes(vista) ? 'white' : '#888', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', fontSize: '0.8rem' }}
          >☰ Altre funzioni ▾</button>
          {menuAperto && (
            <div style={{ position: 'absolute', right: 0, top: '110%', background: 'white', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 100, minWidth: '160px', overflow: 'hidden' }}>
              {[
                { key: 'archivio', label: '🗂️ Archivio', action: () => { setVista('archivio'); caricaArchivio(); setMenuAperto(false); } },
                { key: 'cestino', label: '🗑️ Cestino', action: () => { setVista('cestino'); caricaCestino(); setMenuAperto(false); } },
                { key: 'logs', label: '🔐 Log', action: () => { setVista('logs'); caricaLogs(); setMenuAperto(false); } },
              ].map(item => (
                <button key={item.key} onClick={item.action} style={{ display: 'block', width: '100%', padding: '0.6rem 1rem', background: vista === item.key ? '#f0f0f0' : 'white', border: 'none', borderBottom: '1px solid #f0f0f0', cursor: 'pointer', fontSize: '0.85rem', textAlign: 'left', fontWeight: vista === item.key ? 'bold' : 'normal' }}>
                  {item.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* MODAL password temporanea — visibile una sola volta */}
      {passwordTemporanea?.open && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', maxWidth: '420px', width: '90%' }}>
            <h3 style={{ margin: '0 0 0.5rem', color: '#9f0408' }}>🔐 Password temporanea</h3>
            <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '1rem' }}>
              Utente: <strong>{passwordTemporanea.email}</strong><br />
              Questa password è visibile <strong>una sola volta</strong>.
            </p>
            <div style={{ background: '#f8f8f8', border: '1px solid #ddd', borderRadius: '6px', padding: '0.8rem 1rem', fontFamily: 'monospace', fontSize: '1.1rem', letterSpacing: '0.05em', marginBottom: '1rem' }}>
              {passwordTemporanea.password}
            </div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button
                onClick={() => { navigator.clipboard.writeText(passwordTemporanea.password); }}
                style={{ flex: 1, padding: '0.6rem', background: '#2980b9', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}
              >📋 Copia</button>
              <button
                onClick={() => setPasswordTemporanea(null)}
                style={{ flex: 1, padding: '0.6rem', background: '#7f8c8d', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
              >Chiudi</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL crea mediatore */}
      {modalCreaMediatore.open && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', maxWidth: '400px', width: '90%' }}>
            <h3 style={{ margin: '0 0 1rem', color: '#9f0408' }}>👤 Crea mediatore</h3>
            <div style={{ marginBottom: '0.8rem' }}>
              <label style={{ display: 'block', marginBottom: '0.3rem', fontWeight: 'bold', fontSize: '0.9rem' }}>Email *</label>
              <input
                value={modalCreaMediatore.email}
                onChange={e => setModalCreaMediatore(p => ({ ...p, email: e.target.value }))}
                placeholder="email@esempio.it"
                style={{ width: '100%', padding: '0.6rem', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ marginBottom: '1.2rem' }}>
              <label style={{ display: 'block', marginBottom: '0.3rem', fontWeight: 'bold', fontSize: '0.9rem' }}>Nome</label>
              <input
                value={modalCreaMediatore.nome}
                onChange={e => setModalCreaMediatore(p => ({ ...p, nome: e.target.value }))}
                placeholder="Nome Cognome"
                style={{ width: '100%', padding: '0.6rem', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button onClick={handleCreaMediator} style={{ flex: 1, padding: '0.6rem', background: '#27ae60', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>Crea</button>
              <button onClick={() => setModalCreaMediatore({ open: false, email: '', nome: '' })} style={{ flex: 1, padding: '0.6rem', background: '#7f8c8d', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Annulla</button>
            </div>
          </div>
        </div>
      )}

      {/* SEZIONE MEDIATORI */}
      {vista === 'mediatori' && currentUser?.role === 'superadmin' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h2 style={{ margin: 0 }}>👥 Gestione Mediatori</h2>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button onClick={caricaMediatori} style={{ ...actionBtn, background: '#7f8c8d' }}>🔄 Aggiorna</button>
              <button onClick={() => setModalCreaMediatore({ open: true, email: '', nome: '' })} style={{ ...actionBtn, background: '#27ae60' }}>➕ Crea mediatore</button>
            </div>
          </div>
          {mediatori.length === 0 ? (
            <p style={{ color: '#999' }}>Nessun mediatore presente.</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ background: '#9f0408', color: 'white', textAlign: 'left' }}>
                  <th style={thStyle}>Email</th>
                  <th style={thStyle}>Nome</th>
                  <th style={thStyle}>Stato</th>
                  <th style={thStyle}>Creato il</th>
                  <th style={thStyle}>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {mediatori.map((m: any) => (
                  <tr key={m.id} style={{ borderBottom: '1px solid #ddd', background: m.attivo ? '#fff' : '#fafafa', opacity: m.attivo ? 1 : 0.6 }}>
                    <td style={tdStyle}>{m.email}</td>
                    <td style={tdStyle}>{m.nome || '—'}</td>
                    <td style={tdStyle}>
                      <span style={{ padding: '0.2rem 0.5rem', borderRadius: '4px', fontSize: '0.8rem', background: m.attivo ? '#d4efdf' : '#f9ebea', color: m.attivo ? '#1e8449' : '#c0392b', fontWeight: 'bold' }}>
                        {m.attivo ? 'Attivo' : 'Disabilitato'}
                      </span>
                    </td>
                    <td style={tdStyle}>{m.data_creazione ? new Date(m.data_creazione).toLocaleDateString('it-IT') : '—'}</td>
                    <td style={tdStyle}>
                      <div style={{ display: 'flex', gap: '0.4rem' }}>
                        <button onClick={() => handleResetPassword(m.id, m.email)} style={{ ...actionBtn, background: '#e67e22', fontSize: '0.75rem', padding: '0.2rem 0.5rem' }}>🔑 Reset password</button>
                        {m.attivo && (
                          <button onClick={() => handleDisabilitaUtente(m.id, m.email)} style={{ ...actionBtn, background: '#c0392b', fontSize: '0.75rem', padding: '0.2rem 0.5rem' }}>🚫 Disabilita</button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* SEZIONE LOG */}
      {vista === 'logs' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h2 style={{ margin: 0 }}>🔐 Log Accessi</h2>
            <button onClick={caricaLogs} style={{ ...actionBtn, background: '#7f8c8d' }}>🔄 Aggiorna</button>
          </div>
          {logs.length === 0 ? <p>Nessun log disponibile.</p> : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ background: '#9f0408', color: 'white', textAlign: 'left' }}>
                  <th style={thStyle}>Data e ora</th>
                  <th style={thStyle}>Utente</th>
                  <th style={thStyle}>Azione</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((l: any) => (
                  <tr key={l.id} style={{ borderBottom: '1px solid #ddd', background: l.azione.includes('FALLITO') ? '#fdecea' : '#fff' }}>
                    <td style={tdStyle}>{new Date(l.timestamp).toLocaleString('it-IT')}</td>
                    <td style={tdStyle}>{l.utente}</td>
                    <td style={{ ...tdStyle, color: l.azione.includes('FALLITO') ? '#c0392b' : '#27ae60', fontWeight: 'bold' }}>
                      {l.azione.includes('FALLITO') ? '❌ ' : '✅ '}{l.azione}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* CESTINO */}
      {vista === 'cestino' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h2 style={{ margin: 0 }}>🗑️ Cestino</h2>
            <button onClick={caricaCestino} style={{ ...actionBtn, background: '#7f8c8d' }}>🔄 Aggiorna</button>
          </div>
          <p style={{ color: '#888', fontSize: '0.85rem', marginBottom: '1.5rem' }}>Gli elementi vengono eliminati definitivamente dopo 2 giorni.</p>

          <h3 style={{ color: '#9f0408' }}>Procedure</h3>
          {cestino.procedure.length === 0 ? <p style={{ color: '#999' }}>Nessuna procedura nel cestino.</p> : (
            cestino.procedure.map((p: any) => (
              <div key={p.id} style={{ ...cardStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <strong>{p.protocollo}</strong>
                  <span style={{ color: '#666', marginLeft: '1rem', fontSize: '0.9rem' }}>{p.parte1} vs {p.parte2}</span>
                  <span style={{ marginLeft: '1rem', fontSize: '0.8rem', color: p.giorni_rimasti <= 0 ? '#c0392b' : '#e67e22' }}>
                    {p.giorni_rimasti > 0 ? `⏳ Eliminazione definitiva tra ${p.giorni_rimasti} giorno/i` : '⚠️ Eliminazione imminente'}
                  </span>
                </div>
                <button onClick={() => ripristinaProceduraClick(p.id)} style={{ ...actionBtn, background: '#27ae60' }}>↩️ Ripristina</button>
              </div>
            ))
          )}

          <h3 style={{ color: '#9f0408', marginTop: '1.5rem' }}>Verbali</h3>
          {cestino.verbali.length === 0 ? <p style={{ color: '#999' }}>Nessun verbale nel cestino.</p> : (
            cestino.verbali.map((v: any) => (
              <div key={v.id} style={{ ...cardStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <strong>Verbale n.{v.numero} del {v.data_verbale}</strong>
                  <span style={{ color: '#666', marginLeft: '1rem', fontSize: '0.9rem' }}>Procedura: {v.procedura_protocollo}</span>
                  <span style={{ marginLeft: '1rem', fontSize: '0.8rem', color: v.giorni_rimasti <= 0 ? '#c0392b' : '#e67e22' }}>
                    {v.giorni_rimasti > 0 ? `⏳ Eliminazione definitiva tra ${v.giorni_rimasti} giorno/i` : '⚠️ Eliminazione imminente'}
                  </span>
                </div>
                <button onClick={() => ripristinaVerbaleClick(v.id)} style={{ ...actionBtn, background: '#27ae60' }}>↩️ Ripristina</button>
              </div>
            ))
          )}
        </div>
      )}

      {/* ARCHIVIO */}
      {vista === 'archivio' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h2 style={{ margin: 0 }}>🗂️ Archivio Verbali</h2>
            <button onClick={caricaArchivio} style={{ ...actionBtn, background: '#7f8c8d' }}>🔄 Aggiorna</button>
          </div>
          <input
            value={ricercaArchivio}
            onChange={e => setRicercaArchivio(e.target.value)}
            placeholder="🔍 Cerca per protocollo o parti..."
            style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.9rem', marginBottom: '1.2rem', boxSizing: 'border-box' }}
          />
          {archivio.length === 0 ? <p style={{ color: '#999' }}>Nessun verbale in archivio.</p> : (
            (() => {
              const q = ricercaArchivio.toLowerCase();
              const parseProto = (proto: string) => {
                const m = proto.match(/(\d+)[_/](\d+)/);
                if (!m) return { num: 0, anno: 0 };
                const n = parseInt(m[2]); return { num: parseInt(m[1]), anno: n < 100 ? n + 2000 : n };
              };

              // Separa verbali orfani (senza procedura_id E senza protocollo catalogato)
              const orfani = archivio.filter((v: any) => !v.procedura_id && (!v.procedura_protocollo || v.procedura_protocollo === '—'));
              const conProc = archivio.filter((v: any) => !!v.procedura_id || (v.procedura_protocollo && v.procedura_protocollo !== '—'));

              // Raggruppa per anno — usa procedura_id come chiave se presente, altrimenti protocollo_archiviato
              const perAnno: {[anno: number]: {[key: string]: {protocollo: string, parte1: string, parte2: string, verbali: any[]}}} = {};
              conProc.forEach((v: any) => {
                const anno = parseProto(v.procedura_protocollo || '').anno || new Date(v.archiviato_il).getFullYear();
                const key = v.procedura_id != null ? String(v.procedura_id) : `proto_${v.procedura_protocollo}`;
                if (!perAnno[anno]) perAnno[anno] = {};
                if (!perAnno[anno][key]) perAnno[anno][key] = { protocollo: v.procedura_protocollo, parte1: v.procedura_parte1, parte2: v.procedura_parte2, verbali: [] };
                perAnno[anno][key].verbali.push(v);
              });

              const anniOrdinati = Object.keys(perAnno).map(Number).sort((a, b) => b - a);

              const filtroPerProc = (proc: {protocollo: string, parte1: string, parte2: string}) =>
                !q || proc.protocollo.toLowerCase().includes(q) || proc.parte1.toLowerCase().includes(q) || proc.parte2.toLowerCase().includes(q);

              const filtroOrfani = orfani.filter((v: any) =>
                !q || (v.procedura_protocollo || '').toLowerCase().includes(q) || (v.procedura_parte1 || '').toLowerCase().includes(q) || (v.procedura_parte2 || '').toLowerCase().includes(q)
              );

              return (
                <>
                  {/* Verbali orfani (senza procedura) */}
                  {filtroOrfani.length > 0 && (
                    <div style={{ ...cardStyle, marginBottom: '1rem', borderLeft: '4px solid #e67e22' }}>
                      <strong style={{ color: '#e67e22' }}>⚠️ Verbali non catalogati</strong>
                      <p style={{ fontSize: '0.85rem', color: '#888', marginTop: '0.3rem', marginBottom: '0.8rem' }}>Questi verbali non hanno una procedura associata. Inserisci i dati per catalogarli correttamente.</p>
                      {filtroOrfani.map((v: any) => (
                        <div key={v.id} style={{ padding: '0.6rem 0.8rem', background: '#fff8f0', borderRadius: '6px', marginBottom: '0.5rem', border: '1px solid #f0c070' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: editOrphanId === v.id ? '0.6rem' : 0 }}>
                            <span style={{ fontSize: '0.9rem', color: '#444' }}>
                              Verbale n.{v.numero} del {v.data_verbale}
                              {v.archiviato_il && <span style={{ color: '#aaa', fontSize: '0.8rem', marginLeft: '0.8rem' }}>archiviato il {new Date(v.archiviato_il).toLocaleDateString('it-IT')}</span>}
                            </span>
                            <div style={{ display: 'flex', gap: '0.5rem' }}>
                              <button onClick={() => { setEditOrphanId(v.id); setEditOrphanForm({ protocollo: v.procedura_protocollo || '', parte1: v.procedura_parte1 || '', parte2: v.procedura_parte2 || '' }); }} style={{ ...actionBtn, background: '#e67e22', fontSize: '0.8rem' }}>✏️ Cataloga</button>
                              <button onClick={() => scaricaArchivio(v)} style={{ ...actionBtn, background: '#2980b9', fontSize: '0.8rem' }}>👁️</button>
                              <button onClick={() => eliminaArchivio(v.id)} style={{ ...actionBtn, background: '#c0392b', fontSize: '0.8rem' }}>🗑️</button>
                            </div>
                          </div>
                          {editOrphanId === v.id && (
                            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', alignItems: 'center' }}>
                              <input value={editOrphanForm.protocollo} onChange={e => setEditOrphanForm(f => ({ ...f, protocollo: e.target.value }))} placeholder="Protocollo (es. 76_2026)" style={{ flex: 1, minWidth: '100px', padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }} />
                              <input value={editOrphanForm.parte1} onChange={e => setEditOrphanForm(f => ({ ...f, parte1: e.target.value }))} placeholder="Parte 1" style={{ flex: 2, minWidth: '120px', padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }} />
                              <input value={editOrphanForm.parte2} onChange={e => setEditOrphanForm(f => ({ ...f, parte2: e.target.value }))} placeholder="Parte 2" style={{ flex: 2, minWidth: '120px', padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }} />
                              <button onClick={() => salvaOrfano(v.id)} style={{ ...actionBtn, background: '#27ae60', fontSize: '0.8rem' }}>✅ Salva</button>
                              <button onClick={() => setEditOrphanId(null)} style={{ ...actionBtn, background: '#95a5a6', fontSize: '0.8rem' }}>✕</button>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Verbali per anno */}
                  {anniOrdinati.map(anno => {
                    const procedure = Object.values(perAnno[anno])
                      .filter(filtroPerProc)
                      .sort((a, b) => {
                        const pa = parseProto(a.protocollo), pb = parseProto(b.protocollo);
                        return pa.num - pb.num;
                      });
                    if (procedure.length === 0) return null;
                    const annoAperto = anniArchivioAperti[anno] === true; // default chiuso
                    return (
                      <div key={anno} style={{ marginBottom: '1rem' }}>
                        <div
                          onClick={() => setAnniArchivioAperti(prev => ({ ...prev, [anno]: !annoAperto }))}
                          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', padding: '0.5rem 0.8rem', background: '#2c3e50', borderRadius: '8px', marginBottom: '0.5rem', color: 'white' }}
                        >
                          <span>{annoAperto ? '▼' : '▶'}</span>
                          <strong style={{ fontSize: '1rem' }}>📅 {anno}</strong>
                          <span style={{ fontSize: '0.85rem', color: '#aec', marginLeft: '0.5rem' }}>{procedure.reduce((n, p) => n + p.verbali.length, 0)} verbali</span>
                        </div>
                        {annoAperto && procedure.map(p => (
                          <div key={p.protocollo} style={{ ...cardStyle, marginBottom: '0.6rem', marginLeft: '0.5rem' }}>
                            <div style={{ marginBottom: '0.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <div>
                                <strong style={{ fontSize: '1rem', color: '#9f0408' }}>📁 {p.protocollo}</strong>
                                <span style={{ color: '#555', marginLeft: '1rem', fontSize: '0.9rem' }}>{p.parte1} vs {p.parte2}</span>
                              </div>
                              {p.verbali[0]?.procedura_id && <button onClick={() => { const procId = p.verbali[0]?.procedura_id; const parsed = parseProtocolloForm(p.protocollo); setModificaProcId(procId); setFormModificaProc({ numero: parsed.numero, anno: parsed.anno, parte1: p.parte1, parte2: p.parte2 }); }} style={{ ...actionBtn, background: '#7f8c8d', fontSize: '0.8rem' }}>✏️ Modifica</button>}
                            </div>
                            {modificaProcId !== null && modificaProcId === p.verbali[0]?.procedura_id && (
                              <div style={{ marginBottom: '0.8rem', padding: '0.8rem', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #ddd', display: 'flex', gap: '0.5rem', flexWrap: 'wrap', alignItems: 'center' }}>
                                <input value={formModificaProc.numero} onChange={e => setFormModificaProc(f => ({ ...f, numero: e.target.value }))} placeholder="N. protocollo" style={{ flex: 1, minWidth: '80px', padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }} />
                                <select value={formModificaProc.anno} onChange={e => setFormModificaProc(f => ({ ...f, anno: e.target.value }))} style={{ padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }}>
                                  {ANNI_DROPDOWN.map(a => <option key={a} value={String(a)}>{a}</option>)}
                                </select>
                                <input value={formModificaProc.parte1} onChange={e => setFormModificaProc(f => ({ ...f, parte1: e.target.value }))} placeholder="Parte 1" style={{ flex: 2, minWidth: '120px', padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }} />
                                <input value={formModificaProc.parte2} onChange={e => setFormModificaProc(f => ({ ...f, parte2: e.target.value }))} placeholder="Parte 2" style={{ flex: 2, minWidth: '120px', padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }} />
                                <button onClick={() => salvaModificaProc(p.verbali[0].procedura_id)} style={{ ...actionBtn, background: '#27ae60', fontSize: '0.8rem' }}>✅ Salva</button>
                                <button onClick={() => setModificaProcId(null)} style={{ ...actionBtn, background: '#95a5a6', fontSize: '0.8rem' }}>✕</button>
                              </div>
                            )}
                            {p.verbali.map((v: any) => (
                              <div key={v.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem 0.8rem', background: '#f8f9fa', borderRadius: '6px', marginBottom: '0.4rem', border: '1px solid #e0e0e0' }}>
                                <span style={{ fontSize: '0.9rem', color: '#444' }}>
                                  Verbale n.{v.numero} del {v.data_verbale}
                                  {v.archiviato_il && <span style={{ color: '#aaa', fontSize: '0.8rem', marginLeft: '0.8rem' }}>archiviato il {new Date(v.archiviato_il).toLocaleDateString('it-IT')}</span>}
                                </span>
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                  <button onClick={() => scaricaArchivio(v)} style={{ ...actionBtn, background: '#2980b9', fontSize: '0.8rem' }}>👁️ Visualizza</button>
                                  <button onClick={() => eliminaArchivio(v.id)} style={{ ...actionBtn, background: '#c0392b', fontSize: '0.8rem' }}>🗑️</button>
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    );
                  })}
                  {anniOrdinati.every(anno => Object.values(perAnno[anno]).filter(filtroPerProc).length === 0) && filtroOrfani.length === 0 && (
                    <p style={{ color: '#999' }}>Nessun risultato.</p>
                  )}
                </>
              );
            })()
          )}
        </div>
      )}

      {/* LISTA PROCEDURE */}
      {vista === 'lista' && (
        <div>
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'center' }}>
            <input
              value={ricerca}
              onChange={e => setRicerca(e.target.value)}
              placeholder="🔍 Cerca per protocollo o parti..."
              style={{ flex: 1, padding: '0.5rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.9rem' }}
            />
            <button onClick={() => { setTipoOrdinamento('protocollo'); setOrdinamento(tipoOrdinamento === 'protocollo' && ordinamento === 'asc' ? 'desc' : 'asc'); }} style={{ ...actionBtn, background: tipoOrdinamento === 'protocollo' ? '#2c3e50' : '#95a5a6', whiteSpace: 'nowrap' }}>
              {tipoOrdinamento === 'protocollo' ? (ordinamento === 'asc' ? '↑ Protocollo' : '↓ Protocollo') : '↕ Protocollo'}
            </button>
            <button onClick={() => { setTipoOrdinamento('verbale'); setOrdinamento(tipoOrdinamento === 'verbale' && ordinamento === 'desc' ? 'asc' : 'desc'); }} style={{ ...actionBtn, background: tipoOrdinamento === 'verbale' ? '#2c3e50' : '#95a5a6', whiteSpace: 'nowrap' }}>
              {tipoOrdinamento === 'verbale' ? (ordinamento === 'desc' ? '↓ Verbale recente' : '↑ Verbale meno recente') : '↕ Verbale recente'}
            </button>
          </div>

          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
            {[
              { key: 'tutte', label: '📋 Tutte' },
              { key: 'in_scadenza', label: '⏰ In scadenza' },
              { key: 'firme_completate', label: '🔴 Manca firma mediatore' },
              { key: 'in_corso', label: '🟠 In corso di firma' },
              { key: 'pronta_per_l_invio', label: '🟣 Pronta per l\'invio' },
              { key: 'completata', label: '🟢 Completate' },
            ].map(f => (
              <button key={f.key} onClick={() => setFiltroStato(f.key)} style={{
                padding: '0.4rem 0.8rem', borderRadius: '20px', border: '2px solid',
                borderColor: filtroStato === f.key ? '#2c3e50' : '#ddd',
                background: filtroStato === f.key ? '#2c3e50' : 'white',
                color: filtroStato === f.key ? 'white' : '#555',
                cursor: 'pointer', fontSize: '0.85rem',
                fontWeight: filtroStato === f.key ? 'bold' : 'normal'
              }}>{f.label}</button>
            ))}
          </div>

          <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <label style={{ fontSize: '0.85rem', color: '#555', whiteSpace: 'nowrap' }}>Creato da:</label>
            <select value={filtroCreatore} onChange={e => setFiltroCreatore(e.target.value)} style={{ padding: '0.4rem 0.6rem', borderRadius: '6px', border: '1px solid #ccc', fontSize: '0.85rem', cursor: 'pointer' }}>
              <option value="tutte">Tutte</option>
              <option value="mediatore">Solo create da mediatori</option>
              <option value="segreteria">Solo create dalla segreteria</option>
            </select>
          </div>

          <h2>Procedure ({procedureFiltrate.length})</h2>
          {procedureFiltrate.length === 0 && <p>Nessuna procedura trovata.</p>}

          {procedureFiltrate.map((p: any) => (
            <div key={p.id} id={`procedura-${p.id}`} style={cardStyle}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ cursor: 'pointer', flex: 1 }} onClick={() => toggleProcedura(p.id)}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                    <span style={{ fontSize: '1.1rem' }}>{procedureAperte[p.id] ? '▼' : '▶'}</span>
                    <div>
                      <strong style={{ fontSize: '1rem', color: '#9f0408' }}>📁 {p.protocollo}</strong>
                      <span style={{ marginLeft: '1rem', color: '#555', fontSize: '0.9rem' }}>{p.parte1} vs {p.parte2}</span>
                      <span style={{ marginLeft: '1rem', padding: '0.2rem 0.6rem', borderRadius: '12px', background: statoProcedura(p).colore, color: 'white', fontSize: '0.75rem', fontWeight: 'bold' }}>
                        {statoProcedura(p).label}
                      </span>
                      {p.creato_da?.role === 'mediatore' && (
                        <span style={{ marginLeft: '0.5rem', padding: '0.2rem 0.6rem', borderRadius: '12px', background: '#2980b9', color: 'white', fontSize: '0.75rem', fontWeight: 'bold' }}>
                          👤 {p.creato_da.nome || p.creato_da.email}
                        </span>
                      )}
                      {proceduraHaScadenze(p) && (
                        <span style={{ marginLeft: '0.5rem', padding: '0.2rem 0.6rem', borderRadius: '12px', background: '#e74c3c', color: 'white', fontSize: '0.75rem', fontWeight: 'bold', animation: 'pulse 1.5s infinite' }}>
                          ⚠️ Firma in scadenza
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <button onClick={(e) => { e.stopPropagation(); const parsed = parseProtocolloForm(p.protocollo); setModificaProcId(p.id); setFormModificaProc({ numero: parsed.numero, anno: parsed.anno, parte1: p.parte1, parte2: p.parte2 }); }} style={{ ...actionBtn, background: '#7f8c8d', fontSize: '0.8rem' }}>✏️</button>
                  <button onClick={() => apriNuovoVerbale(p)} style={{ ...actionBtn, background: '#27ae60' }}>➕ Nuovo verbale</button>
                  <button onClick={() => elimina(p.id)} style={{ ...actionBtn, background: '#c0392b' }}>🗑️</button>
                </div>
              </div>
              {modificaProcId === p.id && (
                <div style={{ marginTop: '0.8rem', padding: '0.8rem', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #ddd', display: 'flex', gap: '0.5rem', flexWrap: 'wrap', alignItems: 'center' }}>
                  <input value={formModificaProc.numero} onChange={e => setFormModificaProc(f => ({ ...f, numero: e.target.value }))} placeholder="N. protocollo" style={{ flex: 1, minWidth: '80px', padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }} />
                  <select value={formModificaProc.anno} onChange={e => setFormModificaProc(f => ({ ...f, anno: e.target.value }))} style={{ padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }}>
                    {ANNI_DROPDOWN.map(a => <option key={a} value={String(a)}>{a}</option>)}
                  </select>
                  <input value={formModificaProc.parte1} onChange={e => setFormModificaProc(f => ({ ...f, parte1: e.target.value }))} placeholder="Parte 1" style={{ flex: 2, minWidth: '120px', padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }} />
                  <input value={formModificaProc.parte2} onChange={e => setFormModificaProc(f => ({ ...f, parte2: e.target.value }))} placeholder="Parte 2" style={{ flex: 2, minWidth: '120px', padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }} />
                  <button onClick={() => salvaModificaProc(p.id)} style={{ ...actionBtn, background: '#27ae60', fontSize: '0.8rem' }}>✅ Salva</button>
                  <button onClick={() => setModificaProcId(null)} style={{ ...actionBtn, background: '#95a5a6', fontSize: '0.8rem' }}>✕</button>
                </div>
              )}

              {procedureAperte[p.id] && (
                <div style={{ marginTop: '1rem' }}>
                  {p.verbali && p.verbali.length > 0 && <ChatVerbali proceduraId={p.id} />}
                  {p.verbali && p.verbali.length > 0 ? p.verbali.map((v: any) => (
                    <div key={v.id} style={verbaleCardStyle}>

                      {messaggiVerbale[v.id] && (
                        <div style={{ padding: '0.5rem 0.8rem', marginBottom: '0.5rem', background: messaggiVerbale[v.id].includes('❌') ? '#fdecea' : '#eafaf1', borderRadius: '6px', border: `1px solid ${messaggiVerbale[v.id].includes('❌') ? '#e74c3c' : '#27ae60'}`, fontSize: '0.9rem' }}>
                          {messaggiVerbale[v.id]}
                        </div>
                      )}

                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                        <div>
                          <span style={{ fontWeight: 'bold' }}>Verbale n.{v.numero} del {v.data_verbale}</span>
                          <span style={{ marginLeft: '1rem', padding: '0.2rem 0.6rem', borderRadius: '12px', background: statoColore(v.stato), color: 'white', fontSize: '0.8rem' }}>
                            {v.stato.replace(/_/g, ' ')}
                          </span>
                          {v.solleciti_sospesi && (
                            <span style={{ marginLeft: '0.5rem', padding: '0.2rem 0.6rem', borderRadius: '12px', background: '#7f8c8d', color: 'white', fontSize: '0.75rem' }}>
                              ⏸ Solleciti sospesi
                            </span>
                          )}
                        </div>
                        <button onClick={() => eliminaVerbaleClick(v.id)} style={{ ...actionBtn, background: '#c0392b', fontSize: '0.8rem' }}>🗑️</button>
                      </div>

                      {/* GIORNI SCADENZA */}
                      <div style={{ marginBottom: '0.5rem', fontSize: '0.85rem', color: '#777', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <span>{v.modalita_firma} — scadenza {v.giorni_scadenza}gg</span>
                        {v.stato === 'in_corso' && (
                          <button onClick={() => {
                            setGiorniModificaAperti(prev => ({ ...prev, [v.id]: !prev[v.id] }));
                            setNuoviGiorni(prev => ({ ...prev, [v.id]: v.giorni_scadenza }));
                          }} style={{ ...actionBtn, fontSize: '0.7rem', padding: '0.1rem 0.4rem', background: '#95a5a6' }}>
                            ✏️ Modifica
                          </button>
                        )}
                      </div>

                      {giorniModificaAperti[v.id] && (
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: '0.8rem', padding: '0.5rem', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #ddd' }}>
                          <label style={{ fontSize: '0.85rem' }}>Nuovi giorni scadenza:</label>
                          <input
                            type="number"
                            value={nuoviGiorni[v.id] || v.giorni_scadenza}
                            onChange={e => setNuoviGiorni(prev => ({ ...prev, [v.id]: parseInt(e.target.value) }))}
                            style={{ width: '80px', padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc' }}
                          />
                          <button onClick={() => salvaGiorniScadenza(v.id)} style={{ ...actionBtn, background: '#27ae60', fontSize: '0.8rem' }}>✅ Salva</button>
                          <button onClick={() => setGiorniModificaAperti(prev => ({ ...prev, [v.id]: false }))} style={{ ...actionBtn, background: '#95a5a6', fontSize: '0.8rem' }}>✕</button>
                        </div>
                      )}

                      {/* FIRMATARI */}
                      {v.firmatari && v.firmatari.length > 0 && (
                        <div style={{ marginBottom: '0.8rem' }}>
                          <b>Firmatari:</b>
                          {v.firmatari.map((f: any) => (
                            <div key={f.id}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.3rem' }}>
                                <span style={{ minWidth: '20px' }}>{f.ordine}.</span>
                                <span>{f.nome} — {f.email}</span>
                                <span style={{ padding: '0.1rem 0.5rem', borderRadius: '10px', background: statoFirmatarioColore(f.stato), color: 'white', fontSize: '0.75rem' }}>
                                  {f.stato}
                                </span>
                                {f.data_firma && <span style={{ color: '#27ae60', fontSize: '0.8rem' }}>✅ {new Date(f.data_firma).toLocaleDateString('it-IT')}</span>}
                                {f.stato === 'in_attesa' && f.data_invio_link && f.giorni_limite && (() => {
                                  const scadenza = new Date(new Date(f.data_invio_link).getTime() + f.giorni_limite * 86400000);
                                  const oreRimaste = Math.ceil((scadenza.getTime() - Date.now()) / 3600000);
                                  if (oreRimaste <= 48 && oreRimaste > 0) return <span style={{ color: '#e74c3c', fontSize: '0.78rem', fontWeight: 'bold' }}>⏰ Scade in {oreRimaste}h</span>;
                                  if (oreRimaste <= 0) return <span style={{ color: '#c0392b', fontSize: '0.78rem', fontWeight: 'bold' }}>⛔ Scaduto</span>;
                                  return null;
                                })()}
                                {f.stato === 'in_attesa' && v.stato === 'in_corso' && (
                                  <>
                                    <button onClick={() => salta(f.id, v.id)} style={{ ...actionBtn, background: '#e67e22', fontSize: '0.75rem', padding: '0.2rem 0.5rem' }}>⏭ Salta</button>
                                    <button onClick={() => {
                                      setFirmatariModificaAperti(prev => ({ ...prev, [f.id]: !prev[f.id] }));
                                      setFirmatarioInModifica(prev => ({ ...prev, [f.id]: { nome: f.nome, email: f.email } }));
                                    }} style={{ ...actionBtn, background: '#95a5a6', fontSize: '0.75rem', padding: '0.2rem 0.5rem' }}>✏️</button>
                                  </>
                                )}
                              </div>

                              {firmatariModificaAperti[f.id] && (
                                <div style={{ marginLeft: '1.5rem', marginTop: '0.3rem', padding: '0.5rem', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #ddd' }}>
                                  <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                                    <SuggerimentiRubrica
                                      campo="nome" value={firmatarioInModifica[f.id]?.nome || ''} placeholder="Nome" rubrica={rubrica}
                                      onChange={val => setFirmatarioInModifica(prev => ({ ...prev, [f.id]: { ...prev[f.id], nome: val } }))}
                                      onSelect={voce => setFirmatarioInModifica(prev => ({ ...prev, [f.id]: { nome: voce.nome || '', email: voce.email } }))}
                                      wrapperStyle={{ flex: 2 }}
                                      inputStyle={{ padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }}
                                    />
                                    <SuggerimentiRubrica
                                      campo="email" value={firmatarioInModifica[f.id]?.email || ''} placeholder="Email/PEC" rubrica={rubrica}
                                      onChange={val => setFirmatarioInModifica(prev => ({ ...prev, [f.id]: { ...prev[f.id], email: val } }))}
                                      onSelect={voce => setFirmatarioInModifica(prev => ({ ...prev, [f.id]: { nome: voce.nome || '', email: voce.email } }))}
                                      wrapperStyle={{ flex: 3 }}
                                      inputStyle={{ padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }}
                                    />
                                    <button onClick={() => salvaModificaFirmatario(f.id, v.id)} style={{ ...actionBtn, background: '#27ae60', fontSize: '0.8rem' }}>✅ Salva</button>
                                    <button onClick={() => setFirmatariModificaAperti(prev => ({ ...prev, [f.id]: false }))} style={{ ...actionBtn, background: '#95a5a6', fontSize: '0.8rem' }}>✕</button>
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}

                          {/* AGGIUNGI FIRMATARIO */}
                          {(v.stato === 'in_corso' || v.stato === 'firme_completate') && (
                            <div style={{ marginTop: '0.5rem' }}>
                              <button onClick={() => {
                                setAggiungiAperti(prev => ({ ...prev, [v.id]: !prev[v.id] }));
                                setNuoviFirmatari(prev => ({ ...prev, [v.id]: { nome: '', email: '', ordine: v.firmatari.length + 1, tipo_notifica: 'pec' } }));
                              }} style={{ ...actionBtn, background: '#7f8c8d', fontSize: '0.8rem' }}>
                                ➕ Aggiungi firmatario
                              </button>

                              {aggiungiAperti[v.id] && (
                                <div style={{ marginTop: '0.5rem', padding: '0.8rem', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #ddd' }}>
                                  <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                                    <SuggerimentiRubrica
                                      campo="nome" value={nuoviFirmatari[v.id]?.nome || ''} placeholder="Nome" rubrica={rubrica}
                                      onChange={val => setNuoviFirmatari(prev => ({ ...prev, [v.id]: { ...prev[v.id], nome: val } }))}
                                      onSelect={voce => setNuoviFirmatari(prev => ({ ...prev, [v.id]: { ...prev[v.id], nome: voce.nome || '', email: voce.email } }))}
                                      wrapperStyle={{ flex: 2 }}
                                      inputStyle={{ padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }}
                                    />
                                    <SuggerimentiRubrica
                                      campo="email" value={nuoviFirmatari[v.id]?.email || ''} placeholder="Email/PEC" rubrica={rubrica}
                                      onChange={val => setNuoviFirmatari(prev => ({ ...prev, [v.id]: { ...prev[v.id], email: val } }))}
                                      onSelect={voce => setNuoviFirmatari(prev => ({ ...prev, [v.id]: { ...prev[v.id], nome: voce.nome || '', email: voce.email } }))}
                                      wrapperStyle={{ flex: 3 }}
                                      inputStyle={{ padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }}
                                    />
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                                      <label style={{ fontSize: '0.8rem' }}>Posizione:</label>
                                      <input
                                        type="number"
                                        min={1}
                                        value={nuoviFirmatari[v.id]?.ordine || v.firmatari.length + 1}
                                        onChange={e => setNuoviFirmatari(prev => ({ ...prev, [v.id]: { ...prev[v.id], ordine: parseInt(e.target.value) } }))}
                                        style={{ width: '60px', padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc' }}
                                      />
                                    </div>
                                    <select
                                      value={nuoviFirmatari[v.id]?.tipo_notifica || 'pec'}
                                      onChange={e => setNuoviFirmatari(prev => ({ ...prev, [v.id]: { ...prev[v.id], tipo_notifica: e.target.value } }))}
                                      style={{ padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85rem' }}
                                    >
                                      <option value="pec">PEC</option>
                                      <option value="email">Email</option>
                                    </select>
                                    <button onClick={() => salvaAggiuntaFirmatario(v.id)} style={{ ...actionBtn, background: '#27ae60', fontSize: '0.8rem' }}>✅ Aggiungi</button>
                                    <button onClick={() => setAggiungiAperti(prev => ({ ...prev, [v.id]: false }))} style={{ ...actionBtn, background: '#95a5a6', fontSize: '0.8rem' }}>✕</button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}

                      {/* AZIONI */}
                      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '0.5rem' }}>

                        {v.stato === 'in_corso' && !v.pdf_verbale_path && (
                          <label style={{ ...actionBtn, background: '#2980b9', cursor: 'pointer' }}>
                            📄 Carica PDF verbale
                            <input type="file" accept=".pdf" hidden onChange={e => e.target.files && caricaPdf(v.id, e.target.files[0])} />
                          </label>
                        )}

                        {v.stato === 'in_corso' && v.pdf_verbale_path && (
                          <button onClick={() => avviaFirme(v.id)} style={{ ...actionBtn, background: giroFirmeAvviato(v) ? '#e67e22' : '#27ae60' }}>
                            {giroFirmeAvviato(v) ? '📩 Sollecita firma' : '🚀 Avvia giro firme'}
                          </button>
                        )}

                        {(v.stato === 'firme_completate' || v.stato === 'pronta_per_l_invio') && (
                          <label style={{ ...actionBtn, background: caricandoMediatore[v.id] ? '#6c3483' : '#8e44ad', cursor: caricandoMediatore[v.id] ? 'not-allowed' : 'pointer', opacity: caricandoMediatore[v.id] ? 0.7 : 1 }}>
                            {caricandoMediatore[v.id] ? '⏳ Caricamento...' : v.pdf_mediatore_path ? '🔄 Sostituisci PDF mediatore' : '📎 Carica PDF mediatore'}
                            <input type="file" accept=".pdf,.p7m" hidden disabled={caricandoMediatore[v.id]} onChange={e => e.target.files && caricaMediatore(v.id, e.target.files[0], p.id)} />
                          </label>
                        )}

                        {v.stato === 'pronta_per_l_invio' && (
                          <button onClick={() => inviaFinale(v.id, p.id)} style={{ ...actionBtn, background: '#8e44ad' }}>📬 Invia verbale finale</button>
                        )}

                        {v.stato === 'in_corso' && giroFirmeAvviato(v) && (
                          <button onClick={() => toggleSolleciti(v)} style={{ ...actionBtn, background: v.solleciti_sospesi ? '#27ae60' : '#7f8c8d' }}>
                            {v.solleciti_sospesi ? '▶ Riattiva solleciti' : '⏸ Sospendi solleciti'}
                          </button>
                        )}

                        <button onClick={() => toggleRicevute(v.id)} style={{ ...actionBtn, background: '#34495e' }}>
                          📨 {verbaliAperti[v.id] ? 'Nascondi ricevute' : 'Mostra ricevute PEC'}
                        </button>

                        <button onClick={() => togglePdfSteps(v.id)} style={{ ...actionBtn, background: '#1a5276' }}>
                          📋 {pdfStepsAperti[v.id] ? 'Nascondi versioni PDF' : 'Mostra versioni PDF'}
                        </button>

                        <button onClick={() => setSollecitiRicevuteAperti(prev => ({ ...prev, [v.id]: !prev[v.id] }))} style={{ ...actionBtn, background: '#117a65' }}>
                          📬 {sollecitiRicevuteAperti[v.id] ? 'Nascondi solleciti' : 'Solleciti'}
                        </button>

                      </div>

                      {pdfStepsAperti[v.id] && (
                        <div style={{ marginTop: '1rem', padding: '1rem', background: '#eaf0fb', borderRadius: '6px', border: '1px solid #aac' }}>
                          <b>📋 Versioni PDF firmate</b>
                          {!pdfStepsPerVerbale[v.id] || pdfStepsPerVerbale[v.id].length === 0 ? (
                            <p style={{ color: '#999', marginTop: '0.5rem' }}>Nessuna versione disponibile.</p>
                          ) : (
                            <div style={{ marginTop: '0.5rem' }}>
                              {pdfStepsPerVerbale[v.id].map((s: any) => (
                                <div key={s.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.4rem 0', borderBottom: '1px solid #dde' }}>
                                  <div>
                                    <span style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>{s.descrizione}</span>
                                    <span style={{ color: '#777', fontSize: '0.8rem', marginLeft: '0.8rem' }}>{new Date(s.data_creazione).toLocaleString('it-IT')}</span>
                                    {s.descrizione === 'Verbale da firmare' && !giroFirmeAvviato(v) && (
                                      <span style={{ marginLeft: '0.6rem', fontSize: '0.75rem', color: '#e67e22', fontWeight: 'bold' }}>⚠️ non ancora inviato</span>
                                    )}
                                    {s.descrizione === 'PDF con firma del mediatore' && v.stato === 'pronta_per_l_invio' && (
                                      <span style={{ marginLeft: '0.6rem', fontSize: '0.75rem', color: '#e67e22', fontWeight: 'bold' }}>⚠️ non ancora inviato</span>
                                    )}
                                  </div>
                                  {s.filename?.endsWith('.p7m') ? (
                                    <button onClick={() => scaricaFile(() => downloadPdfStep(s.id), s.filename)} style={{ ...actionBtn, background: '#1a5276', fontSize: '0.75rem', padding: '0.2rem 0.5rem' }}>⬇️ Scarica P7M</button>
                                  ) : (
                                    <button onClick={() => scaricaPdfStep(s.id, p.protocollo, p.parte1, p.parte2, v.data_verbale, s.descrizione)} style={{ ...actionBtn, background: '#1a5276', fontSize: '0.75rem', padding: '0.2rem 0.5rem' }}>👁️ Visualizza</button>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                          <button onClick={() => caricaPdfSteps(v.id)} style={{ ...actionBtn, background: '#7f8c8d', marginTop: '0.5rem', fontSize: '0.8rem' }}>🔄 Aggiorna</button>
                        </div>
                      )}

                      {sollecitiRicevuteAperti[v.id] && (
                        <div style={{ marginTop: '1rem', padding: '1rem', background: '#eafaf1', borderRadius: '6px', border: '1px solid #a9dfbf' }}>
                          <b>📬 Solleciti inviati</b>
                          <TabSolleciti verbaleId={v.id} />
                        </div>
                      )}

                      {verbaliAperti[v.id] && (
                        <div style={{ marginTop: '1rem', padding: '1rem', background: '#f0f4f8', borderRadius: '6px', border: '1px solid #ddd' }}>
                          <b>📨 Ricevute PEC</b>
                          {cooldownVerbali[v.id] > 0
                            ? <button disabled style={{ ...actionBtn, background: '#7f8c8d', fontSize: '0.75rem', padding: '0.2rem 0.5rem', marginLeft: '0.5rem', opacity: 0.5 }}>
                                ⏳ Riprova tra {cooldownVerbali[v.id]}s
                              </button>
                            : <button onClick={() => avviaControlloRicevute(v.id)} style={{ ...actionBtn, background: '#7f8c8d', fontSize: '0.75rem', padding: '0.2rem 0.5rem', marginLeft: '0.5rem' }}>
                                🔄 Controlla ricevute
                              </button>
                          }
                          {!ricevutePerVerbale[v.id] || ricevutePerVerbale[v.id].length === 0 ? (
                            <p style={{ color: '#999', marginTop: '0.5rem' }}>Nessuna ricevuta disponibile.</p>
                          ) : (
                            <div style={{ marginTop: '0.5rem' }}>
                              {ricevutePerVerbale[v.id].map((r: any) => {
                                const isEmail = r.tipo_notifica === 'email';
                                const badge = r.stato === 'archiviato'
                                  ? { icon: '✅', color: '#27ae60', label: 'Archiviato' }
                                  : r.mancata_consegna
                                  ? { icon: '🔴', color: '#e74c3c', label: 'Mancata consegna' }
                                  : r.ricevuta_accettazione && r.ricevuta_consegna
                                  ? { icon: '✅', color: '#27ae60', label: 'Completo' }
                                  : isEmail
                                  ? { icon: '📧', color: '#3498db', label: 'Email' }
                                  : { icon: '⏳', color: '#e67e22', label: 'In attesa' };
                                return (
                                  <div key={r.id} style={{ padding: '0.6rem', marginBottom: '0.4rem', background: 'white', borderRadius: '6px', border: `1px solid ${badge.color}44` }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.4rem' }}>
                                      <div>
                                        <span style={{ fontWeight: 700, marginRight: 8 }}>{r.destinatario}</span>
                                        <span style={{ color: '#888', fontSize: '0.8rem' }}>{r.tipo.replace(/_/g, ' ')}</span>
                                        <span style={{ marginLeft: 8, color: badge.color, fontWeight: 700, fontSize: '0.8rem' }}>{badge.icon} {badge.label}</span>
                                      </div>
                                      <div style={{ display: 'flex', gap: '0.3rem', flexWrap: 'wrap' }}>
                                        {r.ricevuta_accettazione && (
                                          <button onClick={() => scaricaFile(() => downloadAccettazione(r.id), nomeFileRicevuta(p.protocollo, p.parte1, p.parte2, v.data_verbale, r.tipo, 'accettazione', r.destinatario))}
                                            style={{ ...actionBtn, background: '#3498db', fontSize: '0.72rem', padding: '2px 6px' }}>📬 Accettazione</button>
                                        )}
                                        {r.ricevuta_consegna && (
                                          <button onClick={() => scaricaFile(() => downloadConsegna(r.id), nomeFileRicevuta(p.protocollo, p.parte1, p.parte2, v.data_verbale, r.tipo, 'consegna', r.destinatario))}
                                            style={{ ...actionBtn, background: '#3498db', fontSize: '0.72rem', padding: '2px 6px' }}>✉️ Consegna</button>
                                        )}
                                        {r.stato !== 'archiviato' && (r.ricevuta_accettazione || r.ricevuta_consegna || r.mancata_consegna) && (
                                          <button onClick={async () => {
                                            if (r.mancata_consegna && !window.confirm('Attenzione: c\'è una mancata consegna. Archiviare comunque?')) return;
                                            try {
                                              await archiviaInvioPec(r.id);
                                              await caricaRicevute(v.id);
                                            } catch (e) { alert('Errore archiviazione'); }
                                          }} style={{ ...actionBtn, background: '#27ae60', fontSize: '0.72rem', padding: '2px 6px' }}>✅ Archivia</button>
                                        )}
                                      </div>
                                    </div>
                                    {r.mancata_consegna && r.motivo_mancata_consegna && (
                                      <div style={{ marginTop: '0.3rem', fontSize: '0.78rem', color: '#e74c3c' }}>
                                        ⚠️ Motivo: {r.motivo_mancata_consegna}
                                      </div>
                                    )}
                                    {!r.ricevuta_accettazione && !r.mancata_consegna && r.stato !== 'archiviato' && !isEmail && (
                                      <div style={{ marginTop: '0.3rem', fontSize: '0.78rem', color: '#e67e22' }}>
                                        ⏳ In attesa di accettazione e consegna (aggiornamento automatico ogni 5 min)
                                      </div>
                                    )}
                                  </div>
                                )
                              })}
                            </div>
                          )}
                        </div>
                      )}

                    </div>
                  )) : (
                    <p style={{ color: '#999', fontSize: '0.9rem' }}>Nessun verbale ancora.</p>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* NUOVA PROCEDURA */}
      {vista === 'nuova-procedura' && (
        <div>
          <h2>Nuova Procedura</h2>
          <div style={formStyle}>
            <div style={{ marginBottom: '0.8rem' }}>
              <label>Numero protocollo</label><br />
              <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                <input value={formProcedura.numero} onChange={e => setFormProcedura({ ...formProcedura, numero: e.target.value })} placeholder="es. 76" style={{ ...inputStyle, flex: 2 }} />
                <select value={formProcedura.anno} onChange={e => setFormProcedura({ ...formProcedura, anno: e.target.value })} style={{ ...inputStyle, flex: 1 }}>
                  {ANNI_DROPDOWN.map(a => <option key={a} value={String(a)}>{a}</option>)}
                </select>
              </div>
              {formProcedura.numero && <small style={{ color: '#888' }}>Protocollo: {formProcedura.numero}_{formProcedura.anno}</small>}
            </div>
            <div style={{ marginBottom: '0.8rem' }}>
              <label>Parte 1</label><br />
              <input value={formProcedura.parte1} onChange={e => setFormProcedura({ ...formProcedura, parte1: e.target.value })} placeholder="es. Mario Rossi" style={inputStyle} />
            </div>
            <div style={{ marginBottom: '0.8rem' }}>
              <label>Parte 2</label><br />
              <input value={formProcedura.parte2} onChange={e => setFormProcedura({ ...formProcedura, parte2: e.target.value })} placeholder="es. Luigi Bianchi" style={inputStyle} />
            </div>
            <button onClick={creaNuovaProcedura} style={{ ...actionBtn, background: '#27ae60', fontSize: '1rem', padding: '0.8rem 2rem' }}>✅ Crea procedura</button>
          </div>
        </div>
      )}

      {/* NUOVO VERBALE */}
      {vista === 'nuovo-verbale' && proceduraSelezionata && (
        <div>
          <h2>Nuovo Verbale — {proceduraSelezionata.protocollo}</h2>
          <p style={{ color: '#555' }}>{proceduraSelezionata.parte1} vs {proceduraSelezionata.parte2}</p>
          <div style={formStyle}>
            <div style={{ marginBottom: '0.8rem' }}>
              <label>Numero verbale</label><br />
              <input type="number" value={formVerbale.numero} onChange={e => setFormVerbale({ ...formVerbale, numero: parseInt(e.target.value) })} style={inputStyle} />
            </div>
            <div style={{ marginBottom: '0.8rem' }}>
              <label>Data verbale</label><br />
              <input value={formVerbale.data_verbale} onChange={e => setFormVerbale({ ...formVerbale, data_verbale: e.target.value })} placeholder="es. 13/03/2026" style={inputStyle} />
            </div>
            <div style={{ marginBottom: '0.8rem' }}>
              <label>Modalità firma</label><br />
              <select value={formVerbale.modalita_firma} onChange={e => setFormVerbale({ ...formVerbale, modalita_firma: e.target.value })} style={inputStyle}>
                <option value="sequenziale">Sequenziale</option>
                <option value="parallela">Parallela</option>
              </select>
            </div>
            <div style={{ marginBottom: '0.8rem' }}>
              <label>Giorni prima del sollecito / scadenza</label><br />
              <input type="number" value={formVerbale.giorni_scadenza} onChange={e => setFormVerbale({ ...formVerbale, giorni_scadenza: parseInt(e.target.value) })} style={inputStyle} />
            </div>
            <h3>Firmatari</h3>
            {firmatari.map((f, i) => (
              <div key={i} style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem', alignItems: 'center' }}>
                <span style={{ minWidth: '25px', color: '#555' }}>#{f.ordine}</span>
                <SuggerimentiRubrica
                  campo="nome" value={f.nome} placeholder="Nome" rubrica={rubrica}
                  onChange={v => aggiorniFirmatario(i, 'nome', v)}
                  onSelect={voce => { aggiorniFirmatario(i, 'nome', voce.nome || ''); aggiorniFirmatario(i, 'email', voce.email); }}
                  wrapperStyle={{ flex: 2 }}
                  inputStyle={{ padding: '0.4rem', borderRadius: '4px', border: '1px solid #ccc' }}
                />
                <SuggerimentiRubrica
                  campo="email" value={f.email} placeholder="Email/PEC" rubrica={rubrica}
                  onChange={v => aggiorniFirmatario(i, 'email', v)}
                  onSelect={voce => { aggiorniFirmatario(i, 'nome', voce.nome || ''); aggiorniFirmatario(i, 'email', voce.email); }}
                  wrapperStyle={{ flex: 3 }}
                  inputStyle={{ padding: '0.4rem', borderRadius: '4px', border: '1px solid #ccc' }}
                />
                <select value={f.tipo_notifica} onChange={e => aggiorniFirmatario(i, 'tipo_notifica', e.target.value)} style={{ padding: '0.4rem', borderRadius: '4px', border: '1px solid #ccc' }}>
                  <option value="pec">PEC</option>
                  <option value="email">Email</option>
                </select>
                {firmatari.length > 1 && <button onClick={() => rimuoviFirmatario(i)} style={{ ...actionBtn, background: '#c0392b', padding: '0.3rem 0.6rem' }}>✕</button>}
              </div>
            ))}
            <button onClick={aggiungiFirmatario} style={{ ...actionBtn, marginBottom: '1.5rem', background: '#7f8c8d' }}>+ Aggiungi firmatario</button>
            <br />
            <button onClick={creaNuovoVerbale} style={{ ...actionBtn, background: '#27ae60', fontSize: '1rem', padding: '0.8rem 2rem' }}>✅ Crea verbale</button>
          </div>
        </div>
      )}
      {showScrollTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          title="Torna su"
          style={{
            position: 'fixed', bottom: '2rem', right: '2rem', zIndex: 999,
            width: '48px', height: '48px', borderRadius: '50%',
            background: '#9f0408', color: 'white', border: 'none',
            boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
            cursor: 'pointer', fontSize: '1.4rem', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            transition: 'opacity 0.2s'
          }}
        >↑</button>
      )}
    </div>
  );
}

const btnStyle = (attivo: boolean) => ({
  padding: '0.6rem 1.2rem', marginRight: '0.5rem', cursor: 'pointer',
  background: attivo ? '#9f0408' : '#f0f0f0', color: attivo ? 'white' : '#333',
  border: 'none', borderRadius: '6px', fontWeight: 'bold' as const,
  transition: 'background 0.2s'
});

const cardStyle: React.CSSProperties = {
  border: '1px solid #e0e0e0', borderRadius: '10px', padding: '1rem',
  marginBottom: '0.8rem', background: '#fff',
  boxShadow: '0 1px 4px rgba(0,0,0,0.07)'
};

const verbaleCardStyle: React.CSSProperties = {
  border: '1px solid #e8e8e8', borderRadius: '8px', padding: '1rem',
  marginTop: '0.8rem', background: '#fafafa',
  borderLeft: '4px solid #9f0408'
};

const actionBtn: React.CSSProperties = {
  padding: '0.4rem 0.8rem', background: '#9f0408', color: 'white',
  border: 'none', borderRadius: '4px', cursor: 'pointer'
};

const formStyle: React.CSSProperties = {
  background: '#fafafa', padding: '1.5rem', borderRadius: '8px', border: '1px solid #eee'
};

const inputStyle: React.CSSProperties = {
  padding: '0.4rem', width: '100%', boxSizing: 'border-box',
  borderRadius: '4px', border: '1px solid #ccc'
};

const thStyle: React.CSSProperties = {
  padding: '0.5rem', borderBottom: '1px solid #ccc'
};

const tdStyle: React.CSSProperties = {
  padding: '0.5rem', verticalAlign: 'middle'
};